import { connectHook } from 'app/common/components/connect-hook';
import { NotFoundErrorContent } from './not-found-error-content.js';
import { useNotFoundErrorContent } from './not-found-error-content-hook.js';

export default connectHook(NotFoundErrorContent, useNotFoundErrorContent);
